export enum SSOUserRole {
  ADMIN = 'admin',
  INSTRUCTOR = 'instructor',
  STUDENT = 'student',
}

export default class CommunityMember {
  sso_user_role: SSOUserRole
  sso_username: string
  displayable_name: string
  content_library_access: boolean
  has_sound_check: boolean
  id: number
  is_scc_admin: boolean
  auto_generated_password: boolean

  constructor(props: CommunityMember) {
    this.sso_user_role = props.sso_user_role
    this.sso_username = props.sso_username
    this.displayable_name = props.displayable_name
    this.content_library_access = props.content_library_access
    this.has_sound_check = props.has_sound_check
    this.id = props.id
    this.is_scc_admin = props.is_scc_admin
    this.auto_generated_password = props.auto_generated_password
  }
}
